<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-s-comment"></i>
                </div>
                <div class="header-text">
                    <h2>反馈管理</h2>
                    <p>处理用户反馈意见</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="searchForm.feedbackNo" placeholder="搜索反馈编号" clearable size="medium"
                            class="ai-input" @keyup.enter.native="handleSearch"></el-input>
                    </div>
                    <el-select v-model="searchForm.feedbackType" placeholder="反馈类型" clearable size="medium" class="type-select">
                        <el-option label="功能建议" :value="1"></el-option>
                        <el-option label="问题报错" :value="2"></el-option>
                        <el-option label="体验优化" :value="3"></el-option>
                        <el-option label="其他" :value="4"></el-option>
                    </el-select>
                    <el-select v-model="searchForm.sfStatus" placeholder="处理状态" clearable size="medium" class="status-select">
                        <el-option label="待处理" :value="1"></el-option>
                        <el-option label="处理中" :value="2"></el-option>
                        <el-option label="已解决" :value="3"></el-option>
                        <el-option label="已关闭" :value="4"></el-option>
                        <el-option label="已驳回" :value="5"></el-option>
                    </el-select>
                </div>
                <el-button class="ai-btn" @click="handleSearch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn" @click="handleReset">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <!-- Data Table Card -->
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        反馈列表
                    </span>
                    <div class="card-actions">
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            共 {{ pagination.total }} 条反馈
                        </span>
                    </div>
                </div>
                <div class="card-content" v-loading="tableLoading">
                    <el-table :data="tableData" border stripe style="width: 100%">
                        <el-table-column prop="feedbackNo" label="反馈编号" width="180" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="userName" label="提交人" width="100"></el-table-column>
                        <el-table-column prop="sfModel" label="模块" width="80">
                            <template slot-scope="scope">
                                <el-tag :type="getModelTagType(scope.row.sfModel)" size="small">
                                    {{ getModelName(scope.row.sfModel) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="feedbackType" label="反馈类型" width="100">
                            <template slot-scope="scope">
                                <el-tag :type="getTypeTagType(scope.row.feedbackType)" size="small">
                                    {{ getTypeName(scope.row.feedbackType) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="feedbackContent" label="反馈内容" min-width="200" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="sfStatus" label="处理状态" width="100">
                            <template slot-scope="scope">
                                <el-tag :type="getStatusTagType(scope.row.sfStatus)" size="small">
                                    {{ getStatusName(scope.row.sfStatus) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="handleResult" label="处理结果" min-width="150" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.handleResult">{{ scope.row.handleResult }}</span>
                                <span v-else class="no-result">待处理</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createtime" label="提交时间" width="160">
                            <template slot-scope="scope">
                                {{ formatTime(scope.row.createtime) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="230" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="handleView(scope.row)">
                                    <i class="el-icon-view"></i> 查看
                                </el-button>
                                <el-button type="text" size="small" @click="handleProcess(scope.row)" v-if="scope.row.sfStatus !== 3 && scope.row.sfStatus !== 4 && scope.row.sfStatus !== 5">
                                    <i class="el-icon-edit"></i> 处理
                                </el-button>
                                <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #f56c6c">
                                    <i class="el-icon-delete"></i> 删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination-wrapper">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 查看详情弹窗 -->
        <el-dialog title="反馈详情" :visible.sync="viewDialogVisible" width="650px" append-to-body>
            <el-descriptions :column="1" border v-if="currentRow">
                <el-descriptions-item label="反馈编号">{{ currentRow.feedbackNo }}</el-descriptions-item>
                <el-descriptions-item label="提交人">{{ currentRow.userName }}</el-descriptions-item>
                <el-descriptions-item label="模块">
                    <el-tag :type="getModelTagType(currentRow.sfModel)" size="small">
                        {{ getModelName(currentRow.sfModel) }}
                    </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="反馈类型">
                    <el-tag :type="getTypeTagType(currentRow.feedbackType)" size="small">
                        {{ getTypeName(currentRow.feedbackType) }}
                    </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="反馈内容">{{ currentRow.feedbackContent }}</el-descriptions-item>
                <el-descriptions-item label="附件">
                    <div v-if="getAttachments(currentRow.feedbackAttachment).length > 0" class="attachment-list">
                        <el-image
                            v-for="(img, index) in getAttachments(currentRow.feedbackAttachment)"
                            :key="index"
                            :src="img"
                            :preview-src-list="getAttachments(currentRow.feedbackAttachment)"
                            fit="cover"
                            class="attachment-img"
                        ></el-image>
                    </div>
                    <span v-else>无</span>
                </el-descriptions-item>
                <el-descriptions-item label="处理状态">
                    <el-tag :type="getStatusTagType(currentRow.sfStatus)" size="small">
                        {{ getStatusName(currentRow.sfStatus) }}
                    </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="处理结果">{{ currentRow.handleResult || '待处理' }}</el-descriptions-item>
                <el-descriptions-item label="提交时间">{{ formatTime(currentRow.createtime) }}</el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 处理弹窗 -->
        <el-dialog title="处理反馈" :visible.sync="processDialogVisible" width="500px" append-to-body :close-on-click-modal="false">
            <el-form :model="processForm" label-width="100px" size="small">
                <el-form-item label="处理状态">
                    <el-select v-model="processForm.sfStatus" placeholder="请选择处理状态" style="width: 100%">
                        <el-option label="处理中" :value="2"></el-option>
                        <el-option label="已解决" :value="3"></el-option>
                        <el-option label="已关闭" :value="4"></el-option>
                        <el-option label="已驳回" :value="5"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="处理结果">
                    <el-input v-model="processForm.handleResult" type="textarea" :rows="4" placeholder="请输入处理结果或回复内容" maxlength="500" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="processDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmitProcess" :loading="processLoading">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getSysFeedbackList, updateSysFeedbackHandler, deleteSysFeedback } from "../../api/api";

export default {
    name: "FeedbackManagement",
    data() {
        return {
            searchForm: {
                feedbackNo: "",
                feedbackType: null,
                sfStatus: null
            },
            tableData: [],
            tableLoading: false,
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            viewDialogVisible: false,
            processDialogVisible: false,
            processLoading: false,
            currentRow: null,
            processForm: {
                sfId: null,
                sfStatus: 2,
                handleResult: ""
            }
        };
    },
    created() {
        this.getTableData();
    },
    methods: {
        // 格式化时间
        formatTime(time) {
            if (!time) return '-';
            return time;
        },

        // 获取表格数据
        async getTableData() {
            this.tableLoading = true;
            try {
                const res = await getSysFeedbackList({
                    ...this.searchForm,
                    currentPage: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                });
                if (res.status === 200) {
                    this.tableData = res.data || [];
                    this.pagination.total = res.total || 0;
                }
            } finally {
                this.tableLoading = false;
            }
        },

        // 搜索
        handleSearch() {
            this.pagination.currentPage = 1;
            this.getTableData();
        },

        // 重置
        handleReset() {
            this.searchForm = {
                feedbackNo: "",
                feedbackType: null,
                sfStatus: null
            };
            this.pagination.currentPage = 1;
            this.getTableData();
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.getTableData();
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getTableData();
        },

        // 查看
        handleView(row) {
            this.currentRow = row;
            this.viewDialogVisible = true;
        },

        // 处理
        handleProcess(row) {
            this.currentRow = row;
            this.processForm = {
                sfId: row.sfId,
                sfStatus: row.sfStatus === 1 ? 2 : row.sfStatus,
                handleResult: row.handleResult || ""
            };
            this.processDialogVisible = true;
        },

        // 提交处理
        async handleSubmitProcess() {
            if (!this.processForm.handleResult) {
                this.$message.warning("请输入处理结果");
                return;
            }
            this.processLoading = true;
            try {
                const res = await updateSysFeedbackHandler(this.processForm);
                if (res.status === 200) {
                    this.$message.success("处理成功");
                    this.processDialogVisible = false;
                    this.getTableData();
                } else {
                    this.$message.error(res.msg || "处理失败");
                }
            } finally {
                this.processLoading = false;
            }
        },

        // 删除
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: "确认删除该反馈吗？",
                    type: "warning"
                });
                const res = await deleteSysFeedback({ sfId: row.sfId });
                if (res.status === 200) {
                    this.$message.success("删除成功");
                    this.getTableData();
                } else {
                    this.$message.error(res.msg || "删除失败");
                }
            } catch {
                // 取消
            }
        },

        // 获取类型名称
        getTypeName(type) {
            const map = { 1: "功能建议", 2: "问题报错", 3: "体验优化", 4: "其他" };
            return map[type] || "其他";
        },

        // 获取类型标签类型
        getTypeTagType(type) {
            const map = { 1: "primary", 2: "danger", 3: "warning", 4: "info" };
            return map[type] || "info";
        },

        // 获取模块名称
        getModelName(model) {
            const map = { 1: "全局", 2: "课程", 3: "讲师" };
            return map[model] || "全局";
        },

        // 获取模块标签类型
        getModelTagType(model) {
            const map = { 1: "info", 2: "success", 3: "warning" };
            return map[model] || "info";
        },

        // 获取状态名称
        getStatusName(status) {
            const map = { 1: "待处理", 2: "处理中", 3: "已解决", 4: "已关闭", 5: "已驳回" };
            return map[status] || "待处理";
        },

        // 获取状态标签类型
        getStatusTagType(status) {
            const map = { 1: "danger", 2: "warning", 3: "success", 4: "info", 5: "info" };
            return map[status] || "info";
        },

        // 获取附件列表
        getAttachments(attachment) {
            if (!attachment) return [];
            try {
                const parsed = JSON.parse(attachment);
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
    }
};
</script>

<style scoped>
.bento-container {
    padding: 20px;
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    margin-bottom: 20px;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 56px;
    height: 56px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-icon i {
    font-size: 28px;
    color: #fff;
}

.header-text h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: #fff;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-search {
    display: flex;
    align-items: center;
    gap: 10px;
}

.search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.input-icon {
    position: absolute;
    left: 12px;
    color: #909399;
    font-size: 16px;
    z-index: 1;
}

.ai-input {
    width: 200px;
}

.ai-input /deep/ .el-input__inner {
    background: rgba(255, 255, 255, 0.9);
    border: none;
    padding-left: 36px;
    border-radius: 8px;
}

.type-select,
.status-select {
    width: 130px;
}

.type-select /deep/ .el-input__inner,
.status-select /deep/ .el-input__inner {
    background: rgba(255, 255, 255, 0.9);
    border: none;
    border-radius: 8px;
}

.ai-btn {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #fff;
    border-radius: 8px;
    padding: 10px 20px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.ai-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    color: #fff;
}

/* Bento Grid */
.bento-grid {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.bento-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.table-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.card-title i {
    font-size: 20px;
    color: #667eea;
}

.card-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #909399;
}

.ai-hint i {
    font-size: 14px;
}

.card-content {
    padding: 0;
    min-height: 400px;
}

.pagination-wrapper {
    padding: 16px 20px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    justify-content: flex-end;
}

.no-result {
    color: #c0c4cc;
    font-style: italic;
}

.attachment-list {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.attachment-img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #e6e6e6;
}

.attachment-img:hover {
    border-color: #409eff;
}

/* 表格操作按钮样式 */
.el-button--text {
    padding: 4px 8px;
}

.el-button--text i {
    margin-right: 4px;
}
</style>
